import {Button, Loading} from '@carbon/react';

export interface LoadMoreSectionProps {
    currentPage: number;
    totalPages: number;
    loadingMore: boolean;
    buttonText: string;
    recordCountText: string;
    onLoadMore: () => void;
}

export function LoadMoreSection({
    currentPage,
    totalPages,
    loadingMore,
    buttonText,
    recordCountText,
    onLoadMore
}: LoadMoreSectionProps) {
    if (totalPages <= 1) {
        return null;
    }

    return (
        <div className='flex flex-col items-end mb-4 load-more-container'>
            <Button
                kind='primary'
                size='md'
                disabled={currentPage >= totalPages || loadingMore}
                onClick={onLoadMore}
                data-testid='load-more-button'
                renderIcon={loadingMore ? () => <Loading withOverlay={false} small /> : undefined}
            >
                {buttonText}
            </Button>
            <div className='text-sm text-gray-600 mt-2'>
                {recordCountText}
            </div>
        </div>
    );
}
